import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCredentialDto, ApiSettingsDto, CreateApiCredentialRequest } from '../models/api.model';
import { RestUtils } from './rest-utils';

@Injectable()
export class UserApiService {
  http: HttpClient;

  utils = new RestUtils();

  headers = new HttpHeaders();

  constructor(http: HttpClient) {
    this.http = http;
    this.headers = this.headers.set('Content-Type', 'application/json');
  }

  getSettings(userId: number): Observable<ApiSettingsDto> {
    const url = this.utils.buildUrl('ROLE/api/settings', { userId });
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.get<ApiSettingsDto>(url, options);
  }

  createApiSettings(dto: ApiSettingsDto): Observable<ApiSettingsDto> {
    const url = this.utils.buildUrl('ROLE/api/settings');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.post<ApiSettingsDto>(url, dto, options);
  }

  updateApiSettings(dto: ApiSettingsDto): Observable<ApiSettingsDto> {
    const url = this.utils.buildUrl('ROLE/api/settings');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.put<ApiSettingsDto>(url, dto, options);
  }

  listCredentials(): Observable<ApiCredentialDto[]> {
    const url = this.utils.buildUrl('ROLE/api/credentials');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.get<ApiCredentialDto[]>(url, options);
  }

  createCredential(dto: CreateApiCredentialRequest): Observable<ApiCredentialDto> {
    const url = this.utils.buildUrl('ROLE/api/credentials');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.post<ApiCredentialDto>(url, dto, options);
  }

  regenerateCredential(appId: number, dto: CreateApiCredentialRequest): Observable<void> {
    const url = this.utils.buildUrl(`ROLE/api/credentials/${appId}/regenerate`);
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.put<void>(url, dto, options);
  }

  deleteCredential(appId: number): Observable<void> {
    const url = this.utils.buildUrl(`ROLE/api/credentials/${appId}`);
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.delete<void>(url, options);
  }
}
